<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>下单提醒</span>
          </div>

          <el-alert
            title="说明：以下为当前商户下的员工（与员工管理一致），开启短信提醒后，当顾客下单服务并填写预约时间时，系统将自动发送短信通知。"
            type="info"
            :closable="false"
            show-icon
            style="margin-bottom: 20px;"
          />

          <el-table :data="orderRemindInfo.staffList" style="width: 100%" border stripe v-loading="loading">
            <el-table-column prop="staffName" label="员工姓名" align="center" />
            <el-table-column prop="tel" label="手机号" align="center" />
            <el-table-column label="短信提醒" align="center" width="150">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.smsRemind"
                  active-value="Y"
                  inactive-value="N"
                  active-text="开"
                  inactive-text="关"
                  @change="handleSmsRemindChange(scope.row)"
                />
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="orderRemindInfo.total"
            style="margin-top: 20px; text-align: center;"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listShopOrderRemindStaff, saveShopOrderRemindStaff } from '@/api/order/orderRemindApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'OrderRemindManage',
  data() {
    return {
      loading: false,
      shopId: '',
      currentPage: 1,
      pageSize: 10,
      orderRemindInfo: {
        staffList: [],
        total: 0
      }
    }
  },
  created() {
    this.shopId = getShopId()
    this.loadStaffList(1)
  },
  methods: {
    handleCurrentChange(page) {
      this.currentPage = page
      this.loadStaffList(page)
    },
    async loadStaffList(page) {
      this.loading = true
      try {
        const res = await listShopOrderRemindStaff({
          shopId: this.shopId,
          page,
          row: this.pageSize
        })
        this.orderRemindInfo.total = res.total || 0
        this.orderRemindInfo.staffList = res.data || []
      } catch (error) {
        this.$message.error('加载员工列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async handleSmsRemindChange(row) {
      const originalValue = row.smsRemind === 'Y' ? 'N' : 'Y'
      if (row.smsRemind === 'Y' && !row.tel) {
        row.smsRemind = 'N'
        this.$message.warning('该员工未绑定手机号，无法开启短信提醒')
        return
      }
      try {
        await saveShopOrderRemindStaff({
          shopId: this.shopId,
          staffId: row.staffId,
          staffName: row.staffName,
          tel: row.tel,
          smsRemind: row.smsRemind
        })
        this.$message.success(row.smsRemind === 'Y' ? '已开启短信提醒' : '已关闭短信提醒')
      } catch (error) {
        row.smsRemind = originalValue
        this.$message.error(typeof error === 'string' ? error : '保存失败')
      }
    }
  }
}
</script>

<style scoped>
</style>
